module.exports = __webpack_public_path__ + "img/threeextension.2d94384a.svg";